import { useState } from "react";
import { Button } from "react-bootstrap";
import Automations from "./automations/Automations";
import Accounts from "./accounts/Accounts";
import { useMediaQuery } from "react-responsive";

import Lookups from './lookups/Lookups';
import RecurringTransactions from './recurringTransactions/RecurringTransactions';
import BackupLogs from './backupLogs/BackupLogs';
import PushNotifications from './notifications/PushNotifications';
import Account from './account/Account';

const MODES = {
    TAGS: "TAGS",
    CATEGORIES: "CATEGORIES",
    AUTOMATIONS: "AUTOMATIONS",
    ACCOUNTS: "ACCOUNTS",
    RECURRING: "RECURRING",
    BACKUPS: "BACKUPS",
    NOTIFICATIONS: "NOTIFICATIONS",
    ACCOUNT: "ACCOUNT"
};

const MODE_BUTTONS = [
    { mode: MODES.NOTIFICATIONS, label: "התראות" },
    { mode: MODES.BACKUPS, label: "גיבויים" },
    { mode: MODES.AUTOMATIONS, label: "אוטומציות" },
    { mode: MODES.ACCOUNTS, label: "חשבונות" },
    { mode: MODES.RECURRING, label: "פעולות חוזרות" },
    { mode: MODES.TAGS, label: "תגיות" },
    { mode: MODES.CATEGORIES, label: "קטגוריות" },
    { mode: MODES.ACCOUNT, label: "חשבון" }
];

export default function ManagementContainer() {
    const [mode, setMode] = useState(MODES.CATEGORIES);
    const isMobile = useMediaQuery({
        query: "(max-width: 599px)"
    });

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "10px",
                    padding: "0 10px",
                    marginTop: isMobile ? "10px" : "78px",
                    marginBottom: "20px"
                }}
            >
                {MODE_BUTTONS.map(({ mode: buttonMode, label }) => (
                    <Button
                        key={buttonMode}
                        variant={mode === buttonMode ? "primary" : "outline-primary"}
                        onClick={() => setMode(buttonMode)}
                    >
                        {label}
                    </Button>
                ))}
            </div>
            {mode === MODES.AUTOMATIONS &&  <Automations /> }
            {mode === MODES.ACCOUNTS &&  <Accounts /> }
            {mode === MODES.RECURRING && <RecurringTransactions isMobile={isMobile} /> }
            {mode === MODES.BACKUPS && <BackupLogs /> }
            {mode === MODES.NOTIFICATIONS && <PushNotifications isMobile={isMobile} /> }
            {[MODES.TAGS, MODES.CATEGORIES].includes(mode) && <Lookups mode={mode} isMobile={isMobile} /> }
            {mode === MODES.ACCOUNT && <Account isMobile={isMobile} /> }
        </div>
    );
}
